export default __webpack_public_path__ + "static/placement-do-light-b5c8181a839202288a948ed5847e3918a1b48311a70269616febac5f32e34a0c.png";